// tools
import { getDeviceId } from '@tools/amplitude'

type Gtag = (...args: unknown[]) => void

declare global {
  interface Window {
    dataLayer?: unknown[]
    gtag?: Gtag
  }
}

const GTAG_SCRIPT_URL = 'https://www.googletagmanager.com/gtag/js'
const MAX_DEVICE_ID_RETRIES = 10
const DEVICE_ID_RETRY_DELAY_MS = 800

let initialized = false

const loadGtagScript = (measurementId: string): void => {
  const src = `${GTAG_SCRIPT_URL}?id=${measurementId}`
  if (document.querySelector(`script[src="${src}"]`)) return

  const script = document.createElement('script')
  script.src = src
  script.async = true
  document.head.appendChild(script)
}

const gtag: Gtag = function () {
  window.dataLayer = window.dataLayer ?? []
  window.dataLayer.push(arguments)
}

const configureGtag = (measurementId: string, retry: number = 0): void => {
  const deviceId = getDeviceId()

  if (!deviceId && retry < MAX_DEVICE_ID_RETRIES) {
    setTimeout(() => configureGtag(measurementId, retry + 1), DEVICE_ID_RETRY_DELAY_MS)
    return
  }

  if (!deviceId) {
    console.warn('initGoogleAnalytics: amplitude deviceId is not available — configuring without user_id')
  }

  gtag('config', measurementId, deviceId ? { user_id: deviceId } : {})
}

export const initGoogleAnalytics = (): void => {
  if (initialized) return

  const { gaMeasurementId } = useRuntimeConfig().public

  if (!gaMeasurementId) {
    console.warn('initGoogleAnalytics: gaMeasurementId is not defined')
    return
  }

  initialized = true

  window.dataLayer = window.dataLayer ?? []
  window.gtag = gtag

  loadGtagScript(gaMeasurementId)
  gtag('js', new Date())
  configureGtag(gaMeasurementId)
}
